function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 103",
  transform: "translate(-279 -3716)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 31",
  cx: 34.5,
  cy: 33,
  rx: 34.5,
  ry: 33,
  transform: "translate(279 3716)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-compare-arrows",
  d: "M307.254 3753.533h-14.643v4.534h14.643v6.8l8.335-9.067-8.335-9.067v6.8zm12.492-2.267v-6.8h14.643v-4.533h-14.643v-6.8l-8.335 9.067z",
  fill: "#fdf2f0"
}));
var SvgSubJobArrows = function SvgSubJobArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 66"
  }, props), _ref);
};
export default SvgSubJobArrows;